import { Component, EventEmitter, Injector, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CurrenciesContainer, LandingModel } from 'projects/common/model/landingModel';
import { LandingModelService } from 'projects/common/services/landingModel.service';
import { UpaService, UpaTarget } from 'projects/common/services/upa.service';
import { AbstractComponent } from '../abstract.component';

@Component({
  selector: 'multicurrency',
  template: `
    <div class="multicurrency-container" *ngIf="currencies.secondaryCurrency && countryHasMultiCurrency">
      <span class="eva-3-switch">
        <label class="switch-label">
          <input class="switch-input" type="checkbox" (change)="onCurrencyChange($event)">
          <span class="switch-container">
            <span class="switch-circle"></span>
          </span>
        </label>
      </span>
      <span class="label-container">
        <span class="-eva-3-tc-blue-3 -eva-3-bold label-text">{{'multicurrencies.switchText' | translate: {'0': currencies.secondaryCurrency.code} }}</span>
      </span>
    </div>
  `,
  styleUrls: ['./multicurrency.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MulticurrencyComponent extends AbstractComponent implements OnInit {
  private static MODULE_ID = 'CurrencyFilterModule';

  static currencyEvent = new EventEmitter<any>();

  @Input() moduleIndex: number;
  @Input() uniqueId?: string;

  currencies: CurrenciesContainer;
  countryHasMultiCurrency: boolean;

  constructor(injector: Injector) { 
    super(injector);
  }

  ngOnInit(): void {
    const landingModel: LandingModel = this.landingModelService.getLandingModel();
    this.currencies = landingModel.currencies;
    this.countryHasMultiCurrency = landingModel.countryHasMultiCurrency;
  }

  onCurrencyChange(event: any) {
    const checked = event.target.checked;
    if (checked) {
      MulticurrencyComponent.currencyEvent.emit(this.currencies.secondaryCurrency);
    } else {
      MulticurrencyComponent.currencyEvent.emit(this.currencies.primaryCurrency);
    }
    this.trackCurrencyChange();
  }

  private trackCurrencyChange() {
    const label = this.currencies.primaryCurrency.code + ' - ' + this.currencies.secondaryCurrency?.code;
    this.upaService.trackClickTopic({
      label: label,
      moduleId: MulticurrencyComponent.MODULE_ID,
      uniqueId: this.uniqueId,
      moduleIndex: this.moduleIndex,
      target: UpaTarget.SWITCH
    });
  }

  getModuleId(): string {
    return MulticurrencyComponent.MODULE_ID;
  }
}
